import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";
import { WorkspacePlanTier } from "common/interfaces";

const trackEvent = createTrackerForCategory(AmplitudeCategories.PlanPreview);

enum events {
    PlanPreviewEndedDialogOpened = "PlanPreviewEndedDialogOpened",
    PlanPreviewEndedDialogUpgradeClicked = "PlanPreviewEndedDialogUpgradeClicked",
    PlanPreviewEndedDialogUpgradeSuccess = "PlanPreviewEndedDialogUpgradeSuccess",
}

export function PlanPreviewEndedDialogOpened() {
    trackEvent(events.PlanPreviewEndedDialogOpened, {}, { audit: true });
}

export function PlanPreviewEndedDialogUpgradeClicked({ plan, interval }: { plan: WorkspacePlanTier, interval: "year" | "month" }) {
    trackEvent(events.PlanPreviewEndedDialogUpgradeClicked, { plan, interval }, { audit: true });
}

export function PlanPreviewEndedDialogUpgradeSuccess({ plan, interval }: { plan: WorkspacePlanTier, interval: "year" | "month" }) {
    trackEvent(events.PlanPreviewEndedDialogUpgradeSuccess, { plan, interval }, { audit: true });
}
